/**
 * Единая точка правок юридических ссылок ansarium.tech.
 * Документы на ansarium.ru (md-viewer); при смене версии меняйте только URL здесь.
 */
export const ANSARIUM_LEGAL = {
    termsOfUse: {
        title: 'Условия использования',
        url: 'https://main.ansarium.ru/md/MToxNjE2Mjox.DXCfzvAOTlFOXyUWgH7Tc-KM9Mr3txE8ysuxNq9yBdc?file=ansarium.tech-terms-of-use.md&teacher=%231+%D0%90%D0%B4%D0%BC%D0%B8%D0%BD%D0%B8%D1%81%D1%82%D1%80%D0%B0%D1%82%D0%BE%D1%80&upload=1776974366&from=https://ansarium.tech',
    },
    privacyPolicy: {
        title: 'Политика защиты и обработки персональных данных',
        url: 'https://main.ansarium.ru/md/MToxNjE2MTox._iK7XOtozxp09twjNK0IZSBcleGnXwfTtTKd0Atkp6c?file=ansarium.tech-privacy-policy.md&teacher=%231+%D0%90%D0%B4%D0%BC%D0%B8%D0%BD%D0%B8%D1%81%D1%82%D1%80%D0%B0%D1%82%D0%BE%D1%80&upload=1776974360&from=https://ansarium.tech',
    },
    cookiePolicy: {
        title: 'Политика использования файлов cookie',
        url: 'https://main.ansarium.ru/md/MToxNjE2MDox.jBK89Dz4QWvRe-kIXTg2gcbBEENViHQzHZM_wEajMc4?file=ansarium.tech-cookie-policy.md&teacher=%231+%D0%90%D0%B4%D0%BC%D0%B8%D0%BD%D0%B8%D1%81%D1%82%D1%80%D0%B0%D1%82%D0%BE%D1%80&upload=1776974352&from=https://ansarium.tech',
    },
    consentPersonalData: {
        title: 'Согласие посетителя сайта на обработку персональных данных',
        url: 'https://main.ansarium.ru/md/MToxNzIxNTox.lWv7-BaNyB3BJTtpxD4KPo4smb_mmITq12iisF_beuo?file=ansarium.ru-consent-personal-data.md&teacher=%231+%D0%90%D0%B4%D0%BC%D0%B8%D0%BD%D0%B8%D1%81%D1%82%D1%80%D0%B0%D1%82%D0%BE%D1%80&upload=1778090109&from=https://ansarium.tech',
    },
} as const

export type AnsariumLegalDocKey = keyof typeof ANSARIUM_LEGAL
